import {
  WebshopShoppingCartVoucherValidationData,
  webshopShoppingCartValidateVoucherService,
} from '@cldsystems/ws-api-client';
import { useMutation } from '@tanstack/react-query';
import { runtimeHttpClient } from '@/services/services.setup';

const useShoppingCartValidateVoucher = () => {
  return useMutation({
    mutationFn: ({ payload }: { payload: WebshopShoppingCartVoucherValidationData }) =>
      webshopShoppingCartValidateVoucherService({
        httpClient: runtimeHttpClient,
        payload: payload!,
        hasSchema: true,
      })({ params: {}, queries: {} }),
  });
};

export default useShoppingCartValidateVoucher;
